import { mutate } from 'swr';

const invalidateRequest = (name: string) =>
  mutate(
    (key) => {
      if (Array.isArray(key) && key[0] === name) return true;
      return typeof key === 'string' && key.includes(name);
    },
    undefined,
    { revalidate: false },
  );

export default invalidateRequest;
